import request from '@/utils/request'

/** 总部积分商城独立页面，不调用普通pages新增、编辑或发布。 */
export function getPage() {
  return request({ url: 'admin/pages/points-mall', method: 'get' })
}
export function savePage(data) {
  return request({ url: 'admin/pages/points-mall', method: 'put', headers: { 'Content-Type': 'application/json' }, data })
}
